import { useState, useEffect } from 'react'

export const useQueryParam = param => {
  const [resultParam, setResultParam] = useState(null)

  useEffect(() => {
    if (param && typeof param === 'string') {
      const queryString = new URLSearchParams(window?.location?.search)
      setResultParam(queryString?.get(param))
    }
  }, [param])

  return resultParam
}
